import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="https://cdn.ivaluetv.com/public/ivalue transparent white.png" alt="iValue" className="logo-img" />
            <p><b>Confluent</b> Center of Excellence</p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4>Solutions</h4>
              <Link to="#">Real-Time Data Fabric</Link>
              <Link to="#">Security &amp; SIEM Integration</Link>
              <Link to="#">Governed Streaming</Link>
              <Link to="#">Managed Services</Link>
            </div>
            <div className="footer-column">
              <h4>Company</h4>
              <Link to="https://ivaluegroup.com/en-in/corporate/about-us/" target="_blank" rel="noopener noreferrer">About Us</Link>
              <Link to="https://ivaluegroup.com/en-in/careers/working-at-ivalue/" target="_blank" rel="noopener noreferrer">Careers</Link>
              <Link to="https://ivaluegroup.com/en-in/contact-us/" target="_blank" rel="noopener noreferrer">Contact</Link>
            </div>
            <div className="footer-column">
              <h4>Resources</h4>
              <Link to="/siemReference">Case Studies</Link>
              <Link to="/siemReference">Whitepapers</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {year} iValue. All rights reserved.</p>
          <div className="social-links">
            <a href="https://www.linkedin.com/company/ivalue-infosolutions-pvt-ltd" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
            <a href="https://twitter.com/iValueInfoSoln" aria-label="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
